import React, { useCallback } from 'react';

import { useAppDispatch } from '../../../../hooks/react-redux';
import { Button } from '../../../shared/button/Button';
import styles from './Theoretical.module.scss';
import { NettingEngineSurvey, updateNettingEngineData, setShowSummary, setIsChangingQuestion, ISDANettingEngineData, GMRANettingEngineData } from '../store';

interface TheoreticalBooleanQuestionsProps {
    surveyQuestionIndex: number;
    nettingEngineSurvey: NettingEngineSurvey[];
    transitionToQuestionByIncrement: (increment?: number) => void
    transitionToNextQuestion: () => void;
}

export const TheoreticalBooleanQuestions: React.FC<TheoreticalBooleanQuestionsProps> = ({
    surveyQuestionIndex,
    nettingEngineSurvey,
    transitionToQuestionByIncrement,
    transitionToNextQuestion
}) => {
    const dispatch = useAppDispatch();

    const updateBooleanAnswer = useCallback((value: boolean, key: keyof ISDANettingEngineData | keyof GMRANettingEngineData) => {
        dispatch(updateNettingEngineData(key, value));
        dispatch(setIsChangingQuestion(true));
        if (key === 'productTypesKnown' && !value) {
            transitionToQuestionByIncrement(2);
        } else if ((key === 'counterpartyIsMultiBranch' || key === 'counterpartyIsMultiDesignatedCities') && !value) {
            dispatch(setShowSummary(true));
        } else {
            transitionToNextQuestion();
        }
    }, [dispatch, transitionToNextQuestion, transitionToQuestionByIncrement]);

    const { key, note } = nettingEngineSurvey[surveyQuestionIndex];

    return (
        <>
            <div className={styles.surveyButtonWrapper}>
                <Button label='Yes' onClick={() => updateBooleanAnswer(true, key)} />
                <Button label='No' onClick={() => updateBooleanAnswer(false, key)} />
            </div>
            <div className={styles.surveyMessage}>{note || ''}</div>
        </>
    );
};
